import type { RewardPoolLeaderboardUser } from '@shared/api/types/rewardPools';

import { getWinningEntries, RewardPoolTicket } from '@store:web/components/entities/rewardPool';

type Props = {
  user: RewardPoolLeaderboardUser;
};

export const TicketsList = ({ user }: Props) => {
  return (
    <div className="flex flex-col">
      {getWinningEntries(user?.entries).map((entry) => (
        <RewardPoolTicket key={entry.id} code={entry.id} isWinner={true} />
      ))}
    </div>
  );
};
